import { isRestError, REST_ERROR_KIND } from './RestError';

const MAX_RETRY = 2;

// Chỉ thử lại khi lỗi có cơ hội tự hết. 4xx thì thử lại vô nghĩa: 400 không tìm thấy vẫn không
// tìm thấy, còn 429 thử lại chỉ làm bị chặn lâu hơn.
export const shouldRetry = (failureCount, error) => {
  if (failureCount >= MAX_RETRY || !isRestError(error)) return false;
  if (error.kind === REST_ERROR_KIND.NETWORK || error.kind === REST_ERROR_KIND.TIMEOUT) return true;
  return error.kind === REST_ERROR_KIND.HTTP && error.status >= 500;
};

// Object thuần, không import react-query, để app chỉ dùng axios vẫn import lib này được.
// Tắt các mặc định "làm mới ngầm" của TanStack Query vì API public bị giới hạn 20 request/60 giây:
// refetch mỗi lần focus lại tab chỉ tốn lượt gọi mà không đem lại gì cho người tra cứu.
export const DEFAULT_QUERY_OPTIONS = {
  retry: shouldRetry,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  staleTime: 5 * 60 * 1000,
};
